import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/CoursesApi" );

export const listCourses = ( webAccountId, statusId ) => instance.get( `ListCourses?webAccountId=${webAccountId}&subscriptionStatusId=${statusId}` );
